import React, { useMemo, useRef } from 'react';
import { SearchField } from '@vimily/bonjoro-ui-components-v2/SearchField';
import VideoLimitAlert from './Navigation/VideoLimitAlert';
import useUserStats from '~/react-hooks/use-user-stats';
import { openGoto } from './Modals/Goto';
import InviteTeamButton from '../Modules/Common/Components/InviteTeamButton';
import GenericUgradeButton from '../Modules/Common/Components/GenericUpgradeButton';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router';

export const NAV_HEADER_HEIGHT_IN_PX = 70;
export const SHOW_SEARCH_ON_ROUTES = ['/results', '/replies', '/home'];

export default function NavHeaderItems() {
  const target = useRef(document.getElementById('nav-ctas'));
  const location = useLocation();
  const showSearchField = useMemo(
    () =>
      SHOW_SEARCH_ON_ROUTES.some((route) =>
        new RegExp(`${route}`).test(location.pathname)
      ),
    [location]
  );

  const userStats = useUserStats();

  const videoLimitAlert = useMemo(() => {
    if (
      userStats.videoUploadLimitReached ||
      userStats.videoUploadLimitWarning
    ) {
      return (
        <VideoLimitAlert
          limitReached={userStats.videoUploadLimitReached}
          limitWarning={userStats.videoUploadLimitWarning}
          videoLimit={userStats.videoMessageLimit}
          videoRemaining={userStats.videoMessageRemaining}
        />
      );
    }

    return null;
  }, [userStats]);

  if (!target.current) return null;

  return createPortal(
    <>
      {videoLimitAlert}
      <div className='flex gap-x-1 sm:gap-x-5 mr-3 !ml-0 2xl:mr-8'>
        {showSearchField && (
          <SearchField
            onClick={openGoto}
            placeholder='Search'
            className='hidden w-auto max-w-[16rem] 2xmd:!flex'
          />
        )}
        <InviteTeamButton />
        <GenericUgradeButton />
      </div>
    </>,
    target.current
  );
}
